import Label from "components/Label/Label";
import React, { useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import { useDispatch } from "react-redux";
import { updatePassword } from "actions/userActions";
// import { addIdentityCard } from "actions/userActions";

interface IInput {
  value: string;
  warning: string;
}

const AccountPass = () => {
  // const [identityCard, setIdentityCard] = useState<IInput>({ value: "", warning: "" });
  const [password, setPassword] = useState<IInput>({ value: "", warning: "" });
  const [newPassword, setNewPassword] = useState<IInput>({
    value: "",
    warning: "",
  });
  const [newPassword2, setNewPassword2] = useState<IInput>({
    value: "",
    warning: "",
  });

  const dispatch = useDispatch();

  // const handleSubmitIdentityCard = (e: any) => {
  //   if (!identityCard.value) {
  //     setIdentityCard({
  //       value: password.value,
  //       warning: "Masukkan KTP anda",
  //     });
  //   }
  //   if (
  //     identityCard.value &&
  //     !identityCard.warning
  //   ) {
  //     // dispatch(uploadIdentityCard(identityCard.value));
  //   }

  //   e.preventDefault();
  // };

  const handleSubmitPassword = (e: any) => {
    if (!password.value) {
      setPassword({
        value: password.value,
        warning: "Masukkan password lama anda",
      });
    }
    if (!newPassword.value) {
      setNewPassword({
        value: password.value,
        warning: "Masukkan password baru anda",
      });
    }
    if (newPassword.value !== newPassword2.value) {
      setNewPassword2({
        value: newPassword2.value,
        warning: "Masukkan password yang sama",
      });
    }

    if (
      password.value &&
      newPassword.value &&
      newPassword2.value &&
      !password.warning &&
      !newPassword.warning &&
      !newPassword2.warning
    ) {
      dispatch(updatePassword(password.value, newPassword.value));
    }

    e.preventDefault();
  };
  return (
    <div>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Settings</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          {/* Section metode pembayaran */}
          {/* <div className="max-w-2xl">
            <span className="text-xl font-semibold block">Verifikasi KTP</span>
            <br />
            <span className="text-neutral-700 dark:text-neutral-300 block">
              Tambahkan KTP untuk diverifikasi
            </span>
            <form onSubmit={handleSubmitIdentityCard}>
            <div className="relative mt-5 flex justify-center border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md w-1/2">
                <div className="space-y-1 text-center px-6 pt-5 pb-6">
                  <svg
                    className="mx-auto h-12 w-12 text-neutral-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <div className="flex text-sm text-neutral-6000 dark:text-neutral-300">
                    <label className="relative cursor-pointer rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500">
                      <span>Upload</span>
                      <Input 
                        type="file" 
                        className="sr-only"
                        
                        value={identityCard.value}
                        onChange={(e) => {
                          setIdentityCard({ value: e.target.value, warning: "" });
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <span className="text-sm text-red-500">{identityCard.warning}</span>
              </form>
          </div> */}
          <br />
          {/* Section ubah password */}
          <div className="max-w-2xl">
            <span className="text-xl font-semibold block">Ubah Password</span>
            <br />
            <form className=" max-w-xl space-y-6" onSubmit={handleSubmitPassword}>
              <div>
                <Label>Password Lama</Label>
                <Input
                  warning={password.warning}
                  type="password"
                  className="mt-1.5"
                  value={password.value}
                  onChange={(e) => {
                    setPassword({ value: e.target.value, warning: "" });
                  }}
                />
              </div>
              <div>
                <Label>Password Baru</Label>
                <Input
                  warning={newPassword.warning}
                  type="password"
                  className="mt-1.5"
                  value={newPassword.value}
                  onChange={(e) => {
                    setNewPassword({ value: e.target.value, warning: "" });
                  }}
                  onKeyUp={() => {
                    if (newPassword.value.length < 8) {
                      setNewPassword({
                        value: newPassword.value,
                        warning: "Password paling tidak 8 karakter",
                      });
                    }
                  }}
                />
              </div>
              <div>
                <Label>Konfirmasi Password</Label>
                <Input
                  warning={newPassword2.warning}
                  type="password"
                  className="mt-1.5"
                  value={newPassword2.value}
                  onChange={(e) => {
                    setNewPassword2({ value: e.target.value, warning: "" });
                  }}
                  onKeyUp={() => {
                    if (newPassword.value !== newPassword2.value) {
                      setNewPassword2({
                        value: newPassword2.value,
                        warning: "Masukkan password yang sama",
                      });
                    }
                  }}
                />
              </div>
              <div className="pt-2">
                <ButtonPrimary type="submit">Memperbarui Password</ButtonPrimary>
              </div>
            </form>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountPass;
